import React, {Component} from 'react'
import Button from "react-bootstrap/es/Button";

export default class WynikiRozklad extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return <div style={{paddingTop: 25}}>
            {this.props.wyniki.length > 0 ?
                <h5 style={{paddingBottom: 10}}>Rozkład dla trasy: <font
                    style={{color: '#57b13c', fontWeight: 'bold'}}>{this.props.trasa}</font></h5> : null}
            {this.props.wyniki.map((item, index) => {
                return <div className="wynik" style={{padding: 10}}>
                    <div className="row" style={{lineHeight: 1.75}}>
                        <div className="text-right col-sm-1" style={{whiteSpace: 'nowrap'}}>
                            <div className="godzinaOdjazd">{item.godz} <i
                                className="fa fa-arrow-right"> </i></div>
                            <div className="godzinaPrzyjazd">{item.godzPr} <i
                                className="fa fa-arrow-left"> </i>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="miejsceOdjazd">
                                {item.nazPr}
                            </div>
                            <div style={{color: '#858585', fontSize: '0.875rem', paddingTop: 9}}>
                                Trasa: {item.nazTr}
                            </div>
                        </div>
                        <div className="col-sm-3" style={{
                            flex: '0 0 25%', maxWidth: '25%', paddingLeft: 15
                        }}>
                            <div>&nbsp;</div>
                            <div style={{
                                fontSize: '0.875rem', paddingTop: 11,
                                color: '#858585'
                            }}>Czas przejazdu: <i className="fa fa-clock-o"/> {item.ileMin} min
                            </div>
                        </div>
                        <div className="col-sm-2 flexbox">
                            <Button bsStyle={'success'} onClick={() => this.props.pokazSzczegoly(item.idKu)}>Pokaż
                                rozkład</Button>
                        </div>
                    </div>
                    {this.props.wyswietlSzczegoly[item.idKu] &&
                    this.props.renderujSzczegoly(item, false)
                    }
                </div>
            })}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/rozklad/WynikiRozklad.js